import React from 'react';
import { Helmet } from 'react-helmet-async';

interface HelmetProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article' | 'profile';
  siteName?: string;
  twitterCard?: 'summary' | 'summary_large_image' | 'app' | 'player';
  keywords?: string;
}

const HelmetContainer: React.FC<HelmetProps> = ({
  title,
  description,
  image = '/images/social-preview.jpg', // Default social preview image
  url,
  type = 'website',
  siteName = 'Modesto On Ice',
  twitterCard = 'summary_large_image',
  keywords,
}) => {
  // Use provided values or fall back to translations
  const seoTitle = title || 'Modesto On Ice';
  const seoDescription = description || 'Modesto On Ice';

  const fullUrl = url
    ? `${window.location.origin}${url}`
    : window.location.href;
  const fullImageUrl = image.startsWith('http')
    ? image
    : `${window.location.origin}${image}`;

  // Check if current language is Arabic

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={keywords || ''} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={'en_US'} />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Additional Meta Tags */}
      <meta name="image" content={fullImageUrl} />
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default HelmetContainer;
